import * as async from "async";
import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as googleAuth from "googleAuth";
import * as localAPI from "localAPI";
import * as modalDialog from "modalDialog";
import * as mustcache from "mustcache";
import readlangClient from "readlangClient";
import * as languageMap from "shared/languageMap";
import * as utils from "shared/utils";
import validateEmail from "shared/validateEmail";
import * as walkthrough from "walkthrough";

const SignupView = Backbone.View.extend({
  redirectOrReload: function () {
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/login"
    ) {
      window.location.pathname = "/startSignedIn";
    } else {
      window.location.reload();
    }
  },
  // returns validation error or null if all is OK
  validationError: function () {
    const email1 = this.$el
      .find("#signUpForm input[name=email1]")
      .val()
      .toString();
    const password1 = this.$el
      .find("#signUpForm input[name=password1]")
      .val()
      .toString();

    if (email1.length === 0) {
      return "Please enter your email address";
    } else if (!validateEmail(email1)) {
      return "Invalid email address: " + email1;
    } else if (password1.length === 0) {
      return "Please choose a password";
    } else if (password1.length < 5) {
      return "Your password must be at least 5 characters";
    }
  },
  submit: function () {
    const that = this;
    const username1 = that.$el
      .find("#signUpForm input[name=username1]")
      .val()
      .toString();
    const email1 = that.$el
      .find("#signUpForm input[name=email1]")
      .val()
      .toString();
    const password1 = that.$el
      .find("#signUpForm input[name=password1]")
      .val()
      .toString();
    const error = this.validationError();

    if (error) {
      alert(error);
      return;
    }

    // check for typos in common domain names
    if (
      !that.emailSignIn &&
      !_.every(
        [
          "gmail.com",
          "yahoo.com",
          "hotmail.com",
          "gmx.de",
          "googlemail.com",
          "mail.ru",
        ],
        (possible) => {
          const editDistance = utils.levenshteinDistance(
            email1.split("@")[1],
            possible
          );
          return editDistance !== 1;
        }
      )
    ) {
      if (
        !confirm(
          'It looks like you may have mis-typed your email address, are you sure your email ends with "' +
            email1.split("@")[1] +
            '"?'
        )
      ) {
        return;
      }
    }

    that.$el.find("#signUpFormButton").attr("disabled", "disabled");
    that.$el.find("#signUpForm").addClass("syncing");
    that.$el.find(".signUpText").text("Sending...");

    async.series(
      [
        (cb) => {
          if (that.emailSignIn && !that.combinedSignIn) {
            // don't create new account in this case, skip straight to login
            cb();
            return;
          }
          readlangClient.request(
            "POST",
            "/api/user",
            {
              username: username1,
              email: email1,
              password: password1,
              firstLanguage: that.models.user.get("firstLanguage"),
              currentLearningLanguage: that.models.user.get(
                "currentLearningLanguage"
              ),
            },
            (data) => {
              if (data.errorMessage) {
                cb(data.errorMessage);
              } else if (data.success) {
                cb();
              } else {
                console.error("didn't understand response");
                cb("didn't understand response");
              }
            },
            (response) => {
              that.$el.find("#signUpFormButton").removeAttr("disabled");
              that.$el.find("#signUpForm").removeClass("syncing");
              that.$el.find(".signUpText").text("Sign in");

              if (response.data) {
                cb(response.data.errorMessage ?? response.data);
              } else {
                cb("Unknown error");
              }
            },
            { https: true }
          );
        },
        (cb) => {
          const protocol =
            window.location.hostname === "localhost" ||
            /192\.168|10\.102\.80\.232/.test(window.location.hostname)
              ? "http://"
              : "https://";

          $.ajax({
            type: "POST",
            url: protocol + window.location.hostname + "/api/login",
            data: {
              email: email1,
              password: password1,
              rememberMe: true,

              firstLanguage: that.models.user.get("firstLanguage"),
              currentLearningLanguage: that.models.user.get(
                "currentLearningLanguage"
              ),
            },
            xhrFields: {
              withCredentials: true,
            },
            success: function (data) {
              if (typeof data === "string") {
                data = JSON.parse(data);
              }
              if ("success" in data) {
                localAPI.pushSync(
                  readlangClient.remoteRequest.bind(readlangClient),
                  async () => {
                    await localAPI.setLocalMode(false);
                    that.redirectOrReload();
                  }
                );
              } else {
                cb("Email or password not recognized, please try again");
              }
            },
            error: function () {
              cb("Email or password not recognized, please try again");
            },
          });
        },
      ],
      (err) => {
        if (err) {
          that.$el.find(".errorMessage").text(err).fadeIn();
          this.$el.find("#signInFormButton").text("Log in with email").fadeIn();
        }
      }
    );
  },
  initialize: function (options) {
    const that = this;
    this.models = options.models;

    this.$el.html(
      mustcache.render("signup", {
        languageString: walkthrough.hasAchievement("setLanguages")
          ? languageMap.map[that.models.user.get("currentLearningLanguage")]
              .english
          : "",
      })
    );
    this.$el.find('#signUpForm input[name="email1"]').focus();
    this.$el.find('#signUpForm input[name="password1"]').keypress((event) => {
      if (event.which == 10 || event.which == 13) {
        that.submit();
      }
    });
    this.$el.find("#signInFormButton").click(() => that.startSignInMode());
    this.$el.find("#newAccountButton").click(function () {
      if (that.emailSignUp) {
        that.submit();
      } else {
        that.emailSignUp = true;
        that.$el.find("#signInFormButton, .emailLoginNotice").hide();
        that.$el.find(".emailForm").fadeIn();
        that.$el.find(".nameRow").show();
        that.$el.find('input[name="username1"]').focus();
        $(this).text("Create new account");
      }
    });
    this.$el.find(".loginLink").click(async (event) => {
      event.preventDefault();
      event.stopPropagation();

      readlangClient.login();
    });
    // Using a short timeout here because otherwise the button ends up too narrow. I would guess
    // this is because attachSignInClickHandler needs the DOM to be rendered first.
    setTimeout(() => {
      const element = this.$el.find(".googleSignInButton")[0];
      if (!element) {
        // If here, it could be that the view has been removed before the timeout has elapsed
        return;
      }

      googleAuth.attachSignInClickHandler(
        this.$el.find(".googleSignInButton")[0],
        // @ts-ignore
        {},
        () => {
          localAPI.pushSync(
            readlangClient.remoteRequest.bind(readlangClient),
            async () => {
              await localAPI.setLocalMode(false);
              that.redirectOrReload();
            }
          );
        },
        () => {
          console.error("Google login fail");
        }
      );
    }, 50);
    this.$el.find("#forgotPassword").click((event) => {
      event.preventDefault();
      event.stopPropagation();

      const forgotPasswordDialog = $(mustcache.render("forgotPassword", {}));
      const forgotPasswordButton = forgotPasswordDialog.find(
        "#forgotPasswordButton"
      );

      forgotPasswordDialog
        .find("input[name=email]")
        .keypress((keyPressEvent) => {
          if (keyPressEvent.which == 10 || keyPressEvent.which == 13) {
            forgotPasswordButton.click();
          }
        });
      forgotPasswordButton.click(() => {
        $.ajax({
          type: "POST",
          url: "/api/forgotPassword",
          data: {
            email: forgotPasswordDialog.find('input[name="email"]').val(),
          },
          success: function () {
            modalDialog.cancel();
            alert(
              "If an account exists with this email, you should receive an " +
                "email with a link to reset your password soon."
            );
          },
          error: function () {
            alert("error");
          },
        });
      });
      modalDialog.show(forgotPasswordDialog);
      forgotPasswordDialog.find("input[name=email]").focus();
    });

    this.$el
      .find("input")
      .change(() => {
        that.updateSignInButton();
      })
      .keyup(() => {
        that.updateSignInButton();
      });
  },
  startSignInMode: function () {
    if (this.emailSignIn) {
      this.submit();
    } else {
      this.emailSignIn = true;
      this.$el.find(".errorMessage").hide();
      this.$el.find("#newAccountButton, .emailLoginNotice").hide();
      this.$el.find(".emailForm").fadeIn();
      this.$el.find(".nameRow").hide();
      this.$el.find(".forgotPasswordContainer").fadeIn();
      this.$el.find('input[name="email1"]').focus();
      this.$el.find("#signInFormButton").text("Sign in");
    }
  },
  updateSignInButton: function () {
    if (this.validationError()) {
      this.$el.find("#signInFormButton").addClass("validationError");
    } else {
      this.$el.find("#signInFormButton").removeClass("validationError");
    }
  },
  setFocus: function () {
    this.$el.find(".googleSignInButton").focus();
  },
  handleAboutToBeRemoved: function () {
    googleAuth.detachSignInClickHandler(
      this.$el.find(".googleSignInButton")[0]
    );
  },
});

export default SignupView;
